import CtaSection from 'components/BaseHelpers/CtaSection';

import { ComponentProps } from '../../../types/component-props';
import { CoreCallToActionData } from '../../../types/components';

export type CoreCallToActionProps = ComponentProps & CoreCallToActionData;

const CoreCallToAction = (props: CoreCallToActionProps): JSX.Element => {
  const { image, description, eyebrow, heading, link, jumpLinkLabel } = props.fields;

  if (!description && !heading) {
    return <></>;
  }

  return (
    <CtaSection
      eyebrow={eyebrow}
      heading={heading}
      description={description}
      image={image}
      link={link}
      jumpLinkLabel={jumpLinkLabel}
    />
  );
};

export default CoreCallToAction;
